var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSignSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.37,
    height: 38,
    viewBox: "0 0 21.37 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1592e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.56,17.323,7.545,14.977a2.189,2.189,0,0,1,.616-4.29h4.921a4.53,4.53,0,0,1,2.538.779,1.157,1.157,0,0,0,1.447-.148L19.65,8.795a1.2,1.2,0,0,0-.134-1.818A10.5,10.5,0,0,0,13.1,4.75V1.188A1.191,1.191,0,0,0,11.909,0H9.534A1.191,1.191,0,0,0,8.346,1.188V4.75H8.161a8.132,8.132,0,0,0-8.09,8.877A8.5,8.5,0,0,0,6.29,20.8L13.9,23.023a2.189,2.189,0,0,1-.616,4.29H8.361a4.53,4.53,0,0,1-2.538-.779,1.157,1.157,0,0,0-1.447.148L1.793,29.205a1.2,1.2,0,0,0,.134,1.818,10.5,10.5,0,0,0,6.42,2.227v3.563A1.191,1.191,0,0,0,9.534,38h2.375A1.191,1.191,0,0,0,13.1,36.813V33.235a8.384,8.384,0,0,0,7.845-5.4A8.15,8.15,0,0,0,15.56,17.323Z",
    transform: "translate(-0.036)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSignSolid);
export default __webpack_public_path__ + "static/media/dollar-sign-solid.8b6178ae2148bbb226ddcf2ea5dc2c86.svg";
export { ForwardRef as ReactComponent };